export const pauseAllMedia = () => {
  const mediaElements = document.querySelectorAll('video, audio');

  mediaElements.forEach(el => {
    if (el instanceof HTMLMediaElement && !el.paused) {
      el.pause();
    }
  });
};
